export const DF = '1';
export const ELEVAT = 'elevat';
export const XIRGO_V1_VENDOR_ID = 'xirgo';
export const XIRGO_V2_VENDOR_ID = 'xirgov2';
export const EPEC_6200_VENDOR_ID = 'epec_6200';
export const ACTIA_ACU6_VENDOR_ID = 'actia_acu6';
